import { render, staticRenderFns } from "./ButtonWithIconModelA.vue?vue&type=template&id=03b338b6&scoped=true"
import script from "./ButtonWithIconModelA.vue?vue&type=script&lang=js"
export * from "./ButtonWithIconModelA.vue?vue&type=script&lang=js"
import style0 from "./ButtonWithIconModelA.vue?vue&type=style&index=0&id=03b338b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b338b6",
  null
  
)

export default component.exports